import API_BASE from '../../utils/api';
import React, { useState, useEffect } from "react";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Sidebar from "../../components/Sidebar";
// Add this import at the top
import ProfileDropdown from "../../components/ProfileDropdown";

const TeacherClass = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [classInfo, setClassInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchClassInfo();
  }, []);

  const fetchClassInfo = async () => {
    try {
      const response = await axios.get(
        `${API_BASE}/classes/my-class`,
      );
      setClassInfo(response.data);
    } catch (error) {
      console.error("Error fetching class info:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  if (loading) {
    return (
      <div className="flex">
        <Sidebar />
        <div className="flex-1 bg-gray-100 flex items-center justify-center h-screen">
          <div className="text-xl">Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex">
      <Sidebar />
      <div className="flex-1 bg-gray-100 min-h-screen">
        <nav className="bg-white shadow-sm sticky top-0 z-10">
          <div className="px-6 py-4 flex justify-between items-center">
            <h1 className="text-2xl font-semibold text-gray-800">My Class</h1>
            <ProfileDropdown />
          </div>
        </nav>

        <div className="p-6">
          {classInfo ? (
            <div className="space-y-6">
              {/* Class Header */}
              <div className="bg-gradient-to-r from-indigo-500 to-purple-600 rounded-lg shadow p-8 text-white">
                <h2 className="text-3xl font-bold mb-2">
                  Class {classInfo.className} - Section {classInfo.section}
                </h2>
                <p className="text-indigo-100">
                  Academic Year: {classInfo.academicYear}
                </p>
                <p className="text-indigo-100 mt-2">
                  Total Students: {classInfo.students?.length || 0}
                </p>
              </div>

              {/* Subjects */}
              <div className="bg-white rounded-lg shadow overflow-hidden">
                <div className="px-6 py-4 bg-green-600 text-white">
                  <h2 className="text-lg font-semibold">Subjects</h2>
                </div>
                <div className="p-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {classInfo.subjects?.map((subject, index) => (
                      <div key={index} className="p-4 bg-gray-50 rounded-lg">
                        <p className="font-medium text-lg">
                          {subject.subjectName}
                        </p>
                        {subject.teacherId && (
                          <p className="text-sm text-gray-500 mt-1">
                            Teacher: {subject.teacherId.name}
                          </p>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Students List */}
              <div className="bg-white rounded-lg shadow overflow-hidden">
                <div className="px-6 py-4 bg-indigo-600 text-white flex justify-between items-center">
                  <h2 className="text-lg font-semibold">Students</h2>
                  <span className="bg-white text-indigo-600 px-3 py-1 rounded-full text-sm">
                    Total: {classInfo.students?.length || 0}
                  </span>
                </div>
                <div className="p-6">
                  <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead className="bg-gray-50">
                        <tr>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                            Roll No
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                            Student Name
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                            Parent
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                            Contact
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {classInfo.students?.map((student) => (
                          <tr key={student._id} className="hover:bg-gray-50">
                            <td className="px-6 py-4 whitespace-nowrap">
                              {student.rollNumber}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap font-medium">
                              {student.name}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                              {student.parentId?.name || "N/A"}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                              {student.phone || "N/A"}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="bg-white rounded-lg shadow p-12 text-center">
              <span className="text-6xl mb-4 block">🏫</span>
              <h2 className="text-xl font-semibold text-gray-800 mb-2">
                No Class Assigned
              </h2>
              <p className="text-gray-500">
                You haven't been assigned any class yet.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TeacherClass;
